<template>
  <div class="action-config-item">
    <div class="mb-4">
      <label for="action-name" class="block text-sm font-semibold text-gray-700">Action Name</label>
      <el-input
        v-model="localStep.label"
        id="action-name"
        placeholder="Enter Action Name"
        clearable
        class="w-full rounded-md"
      />
    </div>
    <el-button @click="openAutoAllocateModal()" type="text" icon="el-icon-s-tools">
      Configure Allocations
    </el-button>
    <!-- Footer Actions -->
    <div class="automation-footer-actions mt-4 flex justify-end gap-2">
      <el-button @click="cancelChanges">Cancel</el-button>
      <el-button type="primary" @click="saveChanges">Save</el-button>
    </div>
    <dialog-component
      :title="'Resource Allocation'"
      :visible="showResourceAllocationDialog"
      :isShowFooter="true"
      :containerWidth="'50%'"
      @before-close="closeAutoAllocateModal"
    >
      <div
        class="dialog-content"
        style="display: flex; justify-content: center; align-items: center; height: 100%"
      >
        <el-form
          label-position="top"
          label-width="120px"
          style="width: 100%; display: flex; flex-direction: column; align-items: flex-start"
        >
          <el-card class="resource-section" style="width: 100%; margin-bottom: 20px">
            <div slot="header" class="clearfix">
              <span style="font-weight: bold">Resource</span>
            </div>
            <div>
              <el-radio-group
                v-model="autoAllocate.resourceType"
                @change="handleResourceTypeChange"
              >
                <el-radio :label="'self'" :disabled="autoAllocate.allocationType === 'self'">
                  Self
                </el-radio>
                <el-radio :label="'other'">Other</el-radio>
              </el-radio-group>

              <el-select
                v-if="autoAllocate.resourceType === 'other'"
                v-model="autoAllocate.selectedResource"
                placeholder="Select Resource"
                style="margin-top: 10px; width: 200px; display: block"
                @change="handleSelectedResourceChange"
              >
                <el-option
                  v-for="(entity, i) in allEntities"
                  :key="i"
                  :label="entity.name"
                  :value="entity._id"
                ></el-option>
              </el-select>

              <div style="display: flex; align-items: center; width: 100%; margin-top: 10px">
                <span style="font-weight: bold; margin-right: 10px">Resource Filters</span>
                <el-select
                  v-model="autoAllocate.resourceFilterId"
                  placeholder="Select Filter"
                  style="width: 200px; display: inline-block; margin-right: 10px"
                >
                  <el-option
                    v-for="filter in resourceEntityFilters"
                    :key="filter._id"
                    :label="filter.filter_name"
                    :value="filter._id"
                  >
                    {{ filter.filter_name }}
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-card>

          <el-card class="allocation-section" style="width: 100%">
            <div slot="header" class="clearfix">
              <span style="font-weight: bold">Allocations</span>
            </div>
            <div>
              <el-radio-group
                v-model="autoAllocate.allocationType"
                @change="handleAllocationTypeChange"
              >
                <el-radio :label="'self'" :disabled="autoAllocate.resourceType === 'self'">
                  Self
                </el-radio>
                <el-radio :label="'other'">Other</el-radio>
              </el-radio-group>

              <el-select
                v-if="autoAllocate.allocationType === 'other'"
                v-model="autoAllocate.selectedAllocation"
                placeholder="Select Allocation"
                style="margin-top: 10px; width: 200px; display: block"
                @change="handleSelectedAllocationChange"
              >
                <el-option
                  v-for="(entity, i) in allEntities"
                  :key="i"
                  :label="entity.name"
                  :value="entity._id"
                ></el-option>
              </el-select>
              <el-select
                v-if="autoAllocate.selectedAllocation"
                v-model="autoAllocate.selectedResourceField"
                placeholder="Select Allocation Field"
                style="margin-top: 10px; width: 200px; display: block"
                @change="handleSelectedAllocationChange"
              >
                <el-option
                  v-for="(field, i) in selectedAlloctationEntityFields"
                  :key="i"
                  :label="field.label"
                  :value="field.key"
                ></el-option>
              </el-select>

              <div style="display: flex; align-items: center; width: 100%; margin-top: 10px">
                <span style="font-weight: bold; margin-right: 10px">No of Allocations</span>
                <el-select
                  v-model="autoAllocate.allocationCountType"
                  placeholder="Select Count Type"
                  style="width: 200px; display: inline-block; margin-right: 10px"
                >
                  <el-option label="Equally" value="equally"></el-option>
                  <el-option label="Number" value="number"></el-option>
                </el-select>
                <el-input-number
                  v-if="autoAllocate.allocationCountType === 'number'"
                  v-model="autoAllocate.allocationNumber"
                  :min="1"
                  placeholder="Allocation No."
                  style="width: 200px; display: inline-block"
                ></el-input-number>
              </div>

              <div style="display: flex; align-items: center; width: 100%; margin-top: 10px">
                <span style="font-weight: bold; margin-right: 10px">Allocation Filters</span>
                <el-select
                  v-model="autoAllocate.allocationFilterId"
                  placeholder="Select Filter"
                  style="width: 200px; display: inline-block; margin-right: 10px"
                >
                  <el-option
                    v-for="filter in allocationEntityFilters"
                    :key="filter._id"
                    :label="filter.filter_name"
                    :value="filter._id"
                  >
                    {{ filter.filter_name }}
                  </el-option>
                </el-select>
              </div>
              <div style="display: flex; align-items: center; width: 100%; margin-top: 10px">
                <el-checkbox
                  v-if="autoAllocate.allocationCountType == 'number'"
                  v-model="autoAllocate.allocateAfterThreshold"
                >
                  Allocate only after unassigned submissions reached this count
                </el-checkbox>
              </div>
            </div>
          </el-card>
        </el-form>
      </div>

      <template #footer>
        <el-button @click="closeAutoAllocateModal">Cancel</el-button>
        <el-button type="primary" @click="closeAutoAllocateModal(true)">Save</el-button>
      </template>
    </dialog-component>
  </div>
</template>

<script>
  import StepEditableMixin from './StepEditableMixin';
  import { fetchAllEntityFiltersByEntity } from '@/repo/filtersRepo';
  import { fetchEntityById } from '../../../../repo/entityRepo';
  import templateBuilderHelper from '../../../../mixins/templateBuilderHelper';
  export default {
    name: 'AutoAllocateAction',
    props: {
      step: Object,
      entityAllFilters: Object,
      allEntities: Array,
      currentEntity: Object,
    },
    mixins: [templateBuilderHelper, StepEditableMixin],
    data() {
      return {
        showResourceAllocationDialog: false,
        resourceEntityFilters: [],
        allocationEntityFilters: [],
        entityData: null,
        selectedAlloctationEntityFields: null,
        autoAllocate: {
          resourceType: null,
          allocationType: null,
          allocationCountType: null,
          allocationNumber: null,
          allocationFilterId: null,
          resourceFilterId: null,
          selectedResource: null,
          selectedAllocation: null,
          selectedResourceField: null,
          allocateAfterThreshold: null,
        },
      };
    },
    methods: {
      async openAutoAllocateModal() {
        this.showResourceAllocationDialog = true;
        if (this.localStep.allocations_object) {
          this.autoAllocate = this.localStep.allocations_object;
          const [
            resourceEntityFilters,
            allocationEntityFilters,
            entityData,
            allocationEntityFields,
          ] = await Promise.all([
            this.localStep.allocations_object.resourceType == 'self'
              ? this.entityAllFilters
              : fetchAllEntityFiltersByEntity({
                  entityId: this.localStep.allocations_object.selectedResource,
                }),
            this.localStep.allocations_object.allocationType == 'self'
              ? this.entityAllFilters
              : fetchAllEntityFiltersByEntity({
                  entityId: this.localStep.allocations_object.selectedAllocation,
                }),
            fetchEntityById(this.localStep.allocations_object.selectedAllocation),
            this.getAllFieldsFromEntity(
              await fetchEntityById(this.localStep.allocations_object.selectedAllocation),
              false,
              false,
              true
            ),
          ]);

          this.resourceEntityFilters = resourceEntityFilters;
          this.allocationEntityFilters = allocationEntityFilters;
          this.entityData = entityData;
          this.selectedAlloctationEntityFields = allocationEntityFields.filter((field) => {
            return (
              field.inputType == 'ENTITY' && field?.entity_id == this.autoAllocate.selectedResource
            );
          });
        } else {
          this.autoAllocate = {
            resourceType: null,
            allocationType: null,
            allocationCountType: null,
            allocationNumber: null,
            selectedResource: null,
            selectedAllocation: null,
            allocateAfterThreshold: null,
          };
          ((this.resourceEntityFilters = []), (this.allocationEntityFilters = []));
        }
      },
      closeAutoAllocateModal(isSave) {
        this.showResourceAllocationDialog = false;
        if (isSave) this.$set(this.localStep, 'allocations_object', this.autoAllocate);
      },
      handleResourceTypeChange(newValue) {
        if (newValue === 'self') {
          this.autoAllocate.selectedResource = this.currentEntity._id;
          this.resourceEntityFilters = this.entityAllFilters;
          this.autoAllocate.allocationType = 'other';
        } else {
          this.resourceEntityFilters = [];
        }
      },
      async handleAllocationTypeChange(newValue) {
        if (newValue === 'self') {
          this.autoAllocate.selectedAllocation = this.currentEntity._id;
          this.allocationEntityFilters = this.entityAllFilters;
          this.autoAllocate.resourceType = 'other';
          this.entityData = await fetchEntityById(this.currentEntity._id);
          this.selectedAlloctationEntityFields = await this.getAllFieldsFromEntity(
            this.entityData,
            false,
            false,
            true
          );
          this.selectedAlloctationEntityFields = this.selectedAlloctationEntityFields.filter(
            (field) => {
              return (
                field.inputType == 'ENTITY' &&
                field?.entity_id == this.autoAllocate.selectedResource
              );
            }
          );
        } else {
          this.allocationEntityFilters = [];
        }
      },
      async handleSelectedResourceChange(newValue) {
        this.resourceEntityFilters = await fetchAllEntityFiltersByEntity({
          entityId: newValue,
        });
      },
      async handleSelectedAllocationChange(newValue) {
        this.allocationEntityFilters = await fetchAllEntityFiltersByEntity({
          entityId: newValue,
        });
        this.entityData = await fetchEntityById(newValue);
        this.selectedAlloctationEntityFields = await this.getAllFieldsFromEntity(
          this.entityData,
          false,
          false,
          true
        );
        this.selectedAlloctationEntityFields = this.selectedAlloctationEntityFields.filter(
          (field) => {
            return (
              field.inputType == 'ENTITY' && field?.entity_id == this.autoAllocate.selectedResource
            );
          }
        );
      },
    },
  };
</script>
